<div class="titles-wrapper">
  <div class="title-container">
    <div class="selector-div-wrapper">
      <p><small>Mostrar</small></p>
      <div class="form-check form-switch">
        <input class="input-switch-sm form-check-input" type="checkbox" role="switch" id="comparator-switch"
          [(ngModel)]="tool.enabled" [checked]="tool.enabled">
      </div>
    </div>
  </div>
  <div *ngIf="tool.enabled">
    <div class="title-container">
      <p>Popup Izquierda</p>
      <div class="p-2">
        <p>Background</p>
        <input class="colorpicker-input" [(ngModel)]="tool.left.background" [value]="tool.left.background"
          [style.background]="tool.left.background" [(colorPicker)]="tool.left.background">
        <p>Color</p>
        <input class="colorpicker-input" [(ngModel)]="tool.left.text_color" [value]="tool.left.text_color"
          [style.background]="tool.left.text_color" [(colorPicker)]="tool.left.text_color">
        <!--         <div class="p-2" *ngIf="indoor && indoor.enabled">
          <div class="d-flex align-items-center">
            <i class="color-blue fa fa-angle-right me-1"></i><p>INDOOR</p>
          </div>
          <div class="p-2 pb-0">

            <p>Background</p>
            <input class="colorpicker-input" [(ngModel)]="tool.left.button_background" [value]="tool.left.button_background"
            [style.background]="tool.left.button_background" [(colorPicker)]="tool.left.button_background">
            <p>Texto</p>
            <input class="colorpicker-input" [(ngModel)]="tool.left.button_color" [value]="tool.left.button_color"
            [style.background]="tool.left.button_color" [(colorPicker)]="tool.left.button_color">
          </div>
        </div> -->
      </div>
    </div>
    <div class="title-container">
      <p>Popup Derecha</p>
      <div class="p-2">
        <p>Background</p>
        <input class="colorpicker-input" [(ngModel)]="tool.right.background" [value]="tool.right.background"
          [style.background]="tool.right.background" [(colorPicker)]="tool.right.background">
        <p>Texto</p>
        <input class="colorpicker-input" [(ngModel)]="tool.right.text_color" [value]="tool.right.text_color"
          [style.background]="tool.right.text_color" [(colorPicker)]="tool.right.text_color">

        <!--         <div class="p-2" >
          <div class="d-flex align-items-center">
            <i class="color-blue fa fa-angle-right me-1"></i><p>INDOOR</p>
          </div>
          <div class="p-2 pb-0">

            <p>Background</p>
            <input class="colorpicker-input" [(ngModel)]="tool.right.button_background" [value]="tool.right.button_background"
            [style.background]="tool.right.button_background" [(colorPicker)]="tool.right.button_background">
            <p>Texto</p>
            <input class="colorpicker-input" [(ngModel)]="tool.right.button_color" [value]="tool.right.button_color"
            [style.background]="tool.right.button_color" [(colorPicker)]="tool.right.button_color">
          </div>
        </div> -->
      </div>
    </div>
  </div>
</div>